module.exports = __webpack_public_path__ + "img/commbk.504d2e06.svg";